<template>

    <div class="container">

        <div class="handle-box-search">

            <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchlegworkWeightLists"
            >搜索</el-button>
            <el-button @click="add_isShow=!add_isShow">添加</el-button>
            <el-button
                    icon="el-icon-refresh-right"
                    @click="refresh"
            >刷新</el-button>

        </div>

        <!-- 表格 -->
        <el-table
                :data="tableData"
                style="width: 100%"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
        >




            <el-table-column
                    prop="id"
                    label="id"
                    width="80"
            >
            </el-table-column>



            <el-table-column
                    prop="name"
                    label="所属城市"
                    width="300"
            >
                <template slot-scope="scope">
                    <el-popover
                            trigger="hover"
                            placement="top"
                    >
                        <p>城市编码: {{ scope.row.city.city_code }}</p>
                        <div slot="reference">
                            <el-tag
                                    size="medium"
                                    style="border:0;background-color:#FFF;color:#333"
                            >{{ scope.row.city.name }}</el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column
                    prop="status.alias"
                    label="状态"
            >
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
                        {{scope.row.status.alias}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                    prop="time.YmdHis"
                    label="创建时间"
            >
            </el-table-column>

            <el-table-column
                    label="操作"
                    width="150"
            >
                <template slot-scope="scope">

                    <el-dropdown
                            type="primary"
                            split-button
                            trigger="click"
                            @click="edit_isShow = !edit_isShow; children = scope.row.legwork_weight_code;"
                    >

                        编辑
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="untying(scope.row.legwork_weight_code)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </template>
            </el-table-column>

        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages
                    :search_data="search_data"
                    :result_data="result_data"
                    @pages_function="pages_function"
            ></pages>
        </div>

        <!-- 添加组件 -->
        <addLegworkSetUp
                :isShow="add_isShow"
                @onSubmit="legworkWeightLists"
        ></addLegworkSetUp>

        <!-- 编辑组件 -->
        <editLegworkSetUp
                :isShow="edit_isShow"
                :data="children"
                @onSubmit="legworkWeightLists"
        ></editLegworkSetUp>

    </div>

</template>

<script>
    var _this;
    import addLegworkSetUp from './addLegworkSetUp.vue';
    import editLegworkSetUp from './editLegworkSetUp.vue';
    export default {
        components: {
            addLegworkSetUp,
            editLegworkSetUp
        },
        data() {
            return {

                add_isShow: false,

                edit_isShow: false,

                children: '',



                val_port_array: '',

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {
            _this = this;
            _this.legworkWeightLists();
        },

        methods: {
            untying(code) {
                _this
                    .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',

                        cancelButtonText: '取消',

                        type: 'warning'
                    })
                    .then(() => {
                        _this
                            .$post('/legwork/delLegworkWeightSubmit', {
                                legwork_weight_code: code
                            })
                            .then((res) => {
                                _this.$message.success('删除成功!');

                                //初始化显示列表
                                _this.legworkWeightLists();
                            })
                            .catch((err) => {});
                    })
                    .catch(() => {
                        _this.$message.info('已取消删除');
                    });
            },
            searchlegworkWeightLists() {
                _this.search_data.page = 1;
                _this.legworkWeightLists();
            },

            legworkWeightLists() {
                _this
                    .$post('/legwork/legworkWeightLists', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                    })
                    .catch((err) => {});
            },
            //翻页组件的回调
            pages_function(search_data) {
                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.legworkWeightLists();
            },

            handleSelectionChange(val) {
                var datalist = [];

                for (var i in val) {
                    datalist.push(val[i].help_code);
                }
                _this.delDriverSubmit_data.help_code_array = datalist;
            },

            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>